import React, { useState } from 'react';
import '../styles/MobileScreener.css';
import '../styles/MobileScreenerForm.css';
import { cardToggleTemplate } from '../theme'; // Using centralized theme template

function ScreenerModeToggle({ currentMode, onModeChange, isMobile = false }) {
  const [isExpanded, setIsExpanded] = useState(true);

  const modes = [
    { key: 'basic', label: 'Basic', description: 'Preset strategies with queue system' },
    { key: 'intermediate', label: 'Intermediate', description: 'Guided parameter selection' }
  ];

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  // Get current mode label for collapsed summary
  const currentModeLabel = modes.find(m => m.key === currentMode)?.label || '';

  if (isMobile) {
    return (
      <div className="msf-mode-toggle">
        {modes.map(mode => (
          <button
            key={mode.key}
            type="button"
            onClick={() => onModeChange(mode.key)}
            className={`msf-mode-segment ${currentMode === mode.key ? 'msf-selected' : ''}`}
          >
            {mode.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="screener-mode-section mb-6">
      <div
        className="collapsible-header"
        onClick={toggleExpanded}
      >
        <div className="collapsible-header-left">
          <span className={`chevron ${isExpanded ? 'rotate-90' : ''}`}>
            ›
          </span>
          <h3>Screener Mode</h3>
          {!isExpanded && (
            <span className="mode-summary">{currentModeLabel}</span>
          )}
        </div>
      </div>

      {isExpanded && (
        <div className="mode-toggle-content">
          <div className="mode-toggle-grid">
            {modes.map((mode) => (
              <button
                key={mode.key}
                onClick={() => onModeChange(mode.key)}
                className={`${cardToggleTemplate.cssClasses.base} ${currentMode === mode.key ? cardToggleTemplate.cssClasses.selected : ''}`}
              >
                <div className={cardToggleTemplate.cssClasses.title}>{mode.label}</div>
                <div className={cardToggleTemplate.cssClasses.subtitle}>{mode.description}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ScreenerModeToggle;